module.exports = __webpack_public_path__ + "img/cnware.0d9ecd8a.svg";